/** @jsxImportSource @emotion/react */
import React from "react";
import "../../../pages/Trade/index.css";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { Token } from "../../../store/global/TokenEnum";
import { Amount } from "../../../types/amount";
import clsx from "clsx";
import { css } from "@emotion/react";
import { CurrencyInput } from "../../general/CurrencyInput/CurrencyInput";

export interface AmountInputProps {
  removeButtonVisible?: boolean;
  symbol: Token;
  disabled?: boolean;
  visible?: boolean;
  onRemove?: () => void;
}

const AmountInput: React.FC<AmountInputProps> = ({
  disabled,
  removeButtonVisible,
  visible,
  symbol,
}) => {
  const colClassName = !removeButtonVisible ? "col-sm-8 col-7" : "";
  const selectedToken = GlobalStore.useState(s => {
    return s.takerTokens.find(e => e.token === symbol);
  });

  const updateGlobalStore = (value: Amount) => {
    GlobalStore.update(s => {
      s.takerTokens = s.takerTokens.map(e => {
        if (e.token === symbol) {
          e.amount = value;
        }
        return e;
      });
    });
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className={`${colClassName} d-flex justify-content-end px-0`}
      css={css`
        ${removeButtonVisible}
      `}
    >
      <div className={clsx({ "input-w-button": true })}>
        <CurrencyInput
          value={selectedToken?.amount ?? new Amount("0")}
          onValueChange={value => {
            updateGlobalStore(value);
          }}
          symbol={symbol}
          disabled={disabled}
          id="o2o-top"
          data-testid={`${symbol}-amount-input`}
          classNames={{ "amt-input-form symbol": true }}
          maxButton={{ symbol }}
        />
      </div>
    </div>
  );
};
export default React.memo(AmountInput);
